<template>
  <ValidationObserver ref="pdd" v-slot="{ handleSubmit, invalid, dirty, touched }" v-if="dtls">
    <common ref="common" />
    <v-card class="h-100 rounded-xl">
      <v-toolbar flat>
        <v-toolbar-title>
          <v-icon left>mdi-account</v-icon>Nominee
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="overflow-80 pt-2">
        <ValidationProvider
          name="Name"
          :rules="{ required: true, max: 50 }"
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="dtls.name"
            outlined
            name="Name"
            label="Name"
            :error-messages="errors"
            dense
          >
          </v-text-field>
        </ValidationProvider>
        <ValidationProvider
          name="Relation"
          v-slot="{ errors }"
          rules="required"
        >
          <v-select
            v-model="selectedRelation"
            :items="relationsList"
            item-text="value"
            outlined
            :error-messages="errors"
            return-object
            label="Relation"
            name="Relation"
            dense
          ></v-select>
        </ValidationProvider>
        <ValidationProvider
          name="Mobile No."
          v-slot="{ errors }"
          :rules="{
            min: 10,
            max: 10,
            numeric: true,
            regex: /[6789][0-9]{9}/,
            required: true,
          }"
        >
          <v-text-field
            outlined
            name="Mobile No."
            label="Mobile No."
            :error-messages="errors"
            v-model="dtls.person.mobileNo"
            dense
          >
          </v-text-field>
        </ValidationProvider>
        <ValidationProvider name="DOB" v-slot="{ errors }" rules="required">
          <DatePicker
            name="DOB"
            label="DOB"
            v-model="dtls.person.dateOfBirth"
            :error-messages="errors"
            :max="today"
            dense
          />
        </ValidationProvider>
        <ValidationProvider
          name="Percentage"
          v-slot="{ errors }"
          :rules="{ required: true, max_value: 100 }"
        >
          <v-text-field
            outlined
            name="Percentage"
            label="Percentage"
            :error-messages="errors"
            v-model="dtls.settlementPercentage"
            append-icon="mdi-percent"
            dense
          >
          </v-text-field>
        </ValidationProvider>
        <ValidationProvider
          name="Bank Name"
          v-slot="{ errors }"
          rules="required"
        >
          <v-text-field
            outlined
            name="Bank Name"
            label="Bank Name"
            :error-messages="errors"
            v-model="dtls.bankName"
            dense
          >
          </v-text-field>
        </ValidationProvider>
        <ValidationProvider name="Account No" v-slot="{ errors }" rules="required">
          <v-text-field
            outlined
            name="Account No"
            label="Account No"
            :error-messages="errors"
            v-model="dtls.accountNo"
            dense
          >
          </v-text-field>
        </ValidationProvider>
        <ValidationProvider
          name="IFSC Code"
          v-slot="{ errors }"
          rules="required"
        >
          <v-text-field
            outlined
            name="IFSC Code"
            label="IFSC Code"
            :error-messages="errors"
            v-model="dtls.ifscCode"
            dense
          >
          </v-text-field>
        </ValidationProvider>
      </v-card-text>
      <v-card-actions class="d-flex justify-end px-6">
        <v-btn color="success" @click="handleSubmit(emitNominee())">Ok</v-btn>
      </v-card-actions>
    </v-card>
  </ValidationObserver>
</template>
<script>
import { callApi } from "@/api/others";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import common from "@/components/tools/common.vue";
import dayjs from 'dayjs';
export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    common,
    DatePicker: () => import("@/components/tools/toolbox/DatePicker.vue"),
  },
  props: {
    nominee: Object,
  },
  data: () => ({
    dtls: "",
    relationsList: [],
    MobileNo: "",
    firstName: "",
    today:dayjs().format("YYYY-MM-DD"),
  }),
  computed: {
    selectedRelation: {
      get: function() {
        return {
          id: this.dtls.relationId,
          value: this.dtls.relation
        };
      },
      set: function(nv) {
        this.dtls.relation = nv.value;
        this.dtls.relationId = nv.id;
      },
    },
  },
  async mounted() {
    this.cloneNominee();
    await this.getRelationsList();
  },
  methods: {
    cloneNominee() {
      this.dtls = JSON.parse(JSON.stringify(this.nominee));
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
    getRelationsList() {
      let url = "/api/wesupport/GeneralMaster/getAllbytype?type=Relations";
      callApi(url, "get", "")
        .then((res) => {
          this.relationsList = res.data;
        })
        .catch((err) => {});
    },
    emitNominee(){
      this.$emit("nomineeChanged",this.dtls)
    },
  },
};
</script>
<style>
.overflow-80 {
  max-height: 80vh;
  overflow: auto;
}
</style>
